import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../components/config"; // Adjust as necessary
import "./FileAttachment.css"; // <-- Import the CSS!
// Adjust the import path as necessary
const FileAttachment = ({
  userId,
  conversationId,
  reciever,
  chatId,
  onMessageSend,
}) => {
  const [imageFile, setImageFile] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [loading, setLoading] = useState(false);

  const selectImage = (event) => {
    if (event.target.files.length > 0) {
      setImageFile(event.target.files[0]);
    }
  };

  const postMessage = async () => {
    setLoading(true);
    let multimediaUrl = null;

    try {
      if (imageFile) {
        const formData = new FormData();
        formData.append("image", imageFile);

        const response = await axios.post(
          `https://srv547457.hstgr.cloud:3020/uploads`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        multimediaUrl = response.data.path;
      }

      const newMsg = {
        date_chat: new Date().toISOString().split("T")[0],
        time_chat: new Date().toISOString().split("T")[1].split(".")[0],
        admin_id: reciever,
        driver_id: userId,
        conversation_id: chatId,
        message: messageText,
        origin: userId,
        message_type: imageFile ? "multimedia" : "text",
        media_url: multimediaUrl || null,
      };

      await axios.post(`${API_URL}/customer_admin_chats`, newMsg);
      await onMessageSend(newMsg);

      setImageFile(null);
      setMessageText("");
    } catch (error) {
      console.error("Failed to send message:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fa-container">
      <label className="fa-file-label">
        <input type="file" accept="image/*" onChange={selectImage} />
        <span className="fa-upload-btn">📎 Attach Image</span>
      </label>
      {imageFile && (
        <div className="fa-file-preview">
          <span role="img" aria-label="image">
            🖼️
          </span>{" "}
          {imageFile.name}
        </div>
      )}
      <textarea
        className="fa-message-input"
        placeholder="Type your message..."
        rows={4}
        value={messageText}
        onChange={(e) => setMessageText(e.target.value)}
        disabled={loading}
        maxLength={8000}
      />
      <button
        className="fa-send-btn"
        onClick={postMessage}
        disabled={loading || (!messageText.trim() && !imageFile)}
        aria-busy={loading}
      >
        {loading ? (
          <span className="fa-loader"></span>
        ) : (
          <>
            Send <span style={{ fontSize: "1.2em" }}>➤</span>
          </>
        )}
      </button>
    </div>
  );
};

export default FileAttachment;
